import LoginView from '@/views/LoginView.vue'
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { useUserStore } from '@/store/user'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/AdminView.vue'),
    meta: {
      requiresAuth: true,
      title: 'E时代通行证 - 管理员后台'
    }
  },
  {
    path: '/oauth/bohrium/callback',
    name: 'bohrium-callback',
    component: () => import('../views/oauth/BohriumCallback.vue'),
    meta: {
      title: 'Bohrium登录回调'
    }
  },
  {
    path: '/oauth/google/callback',
    name: 'google-callback',
    component: () => import('../views/oauth/GoogleCallback.vue'),
    meta: {
      title: 'Google登录回调'
    }
  },
  {
    path: '/oauth/github/callback',
    name: 'github-callback',
    component: () => import('../views/oauth/GithubCallback.vue'),
    meta: {
      title: 'GitHub登录回调'
    }
  },
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { 
      requiresAuth: true,
      title: 'E时代通行证 - 首页'
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue'),
    meta: {
      title: 'E时代通行证 - 关于我们'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: {
      title: 'E时代通行证 - 登录'
    }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/RegisterView.vue'),
    meta: {
      title: 'E时代通行证 - 注册'
    }
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/ProfileView.vue'),
    meta: { 
      requiresAuth: true,
      title: 'E时代通行证 - 个人中心'
    }
  },
  {
    path: '/profile/security',
    name: 'profile-security',
    component: () => import('../views/ProfileView.vue'),
    meta: { 
      requiresAuth: true,
      title: 'E时代通行证 - 登录与安全'
    }
  },
  {
    path: '/profile/basic',
    name: 'profile-basic',
    component: () => import('../views/ProfileView.vue'),
    meta: { 
      requiresAuth: true,
      title: 'E时代通行证 - 基本信息'
    }
  },
  {
    path: '/profile/devices',
    name: 'profile-devices',
    component: () => import('../views/ProfileView.vue'),
    meta: { 
      requiresAuth: true,
      title: 'E时代通行证 - 设备管理'
    }
  },
  {
    path: '/profile/oauth',
    name: 'profile-oauth',
    component: () => import('../views/ProfileView.vue'),
    meta: { 
      requiresAuth: true,
      title: 'E时代通行证 - 授权记录'
    }
  },
  {
    path: '/profile/oauth-clients',
    name: 'profile-oauth-clients',
    component: () => import('../views/ProfileView.vue'),
    meta: { 
      requiresAuth: true,
      title: 'E时代通行证 - OAuth客户端'
    }
  },
  {
    path: '/oauth/qq/callback',
    name: 'qq-callback',
    component: () => import('../views/oauth/QQCallback.vue'),
    meta: {
      title: 'QQ登录回调'
    }
  },
  {
    path: '/oauth/authorize',
    name: 'oauth-authorize',
    component: () => import('../views/oauth/AuthorizeView.vue'),
    meta: { 
      requiresAuth: true,
      title: 'E时代通行证 - 授权'
    }
  },
  {
    path: '/api/oauth2/authorize',
    name: 'api-oauth-authorize',
    component: () => import('../views/oauth/AuthorizeView.vue'),
    meta: { 
      requiresAuth: true,
      title: 'E时代通行证 - 授权'
    }
  },
  {
    path: '/devices',
    name: 'devices',
    component: () => import('../views/DeviceManagementView.vue'),
    meta: { 
      requiresAuth: true,
      title: 'E时代通行证 - 设备管理'
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title as string
  }

  const userStore = useUserStore()
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!userStore.token) {
      next({
        path: '/login',
        query: { 
          redirect: to.path === '/login' ? '/' : to.fullPath 
        }
      })
    } else {
      next()
    }
  } else {
    if (to.path === '/login' && userStore.token) {
      const redirect = to.query.redirect as string
      next(redirect || '/')
    } else {
      next()
    }
  }
})

export default router
